import { render, staticRenderFns } from "./ItemsNotReceived.vue?vue&type=template&id=8de4dbf2&"
import script from "./ItemsNotReceived.vue?vue&type=script&lang=js&"
export * from "./ItemsNotReceived.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports